module.exports = __webpack_public_path__ + "img/paper_2x.eb7488a8.png";